import React from 'react';
import { ErrorBoundary } from '@sentry/react';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import ThemeProvider from 'e100-react-components/lib/theme/themeProvider';
import useMuiGlobalStyles from 'e100-react-components/lib/styles/useGlobalStyles';
import useAuth from 'common/hooks/useAuth';
import useKeepAliveSession from 'common/hooks/useKeepAliveSession';
import AppRoutes from '../../AppRoutes';
import CssBaseline from 'e100-react-components/lib/styles/CssBaseline';
import ErrorBoundaryFallback from './ErrorBoundaryFallback';

import useTheme from './hooks/useTheme';
import useGlobalStyles from './hooks/useGlobalStyles';
import useInitPermissions from './hooks/useInitPermissions';
import useReloadPage from './hooks/useReloadPage';
import useSendYandexEvents from './hooks/useSendYandexEvents';
import Notice from './Notice';

const App = () => {
  useMuiGlobalStyles();
  useReloadPage();
  useGlobalStyles();
  useAuth();
  useInitPermissions();
  useKeepAliveSession();
  useSendYandexEvents();

  const theme = useTheme();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary
        fallback={({ error, resetError }) => (
          <ErrorBoundaryFallback
            error={error as Error}
            resetError={resetError}
          />
        )}
      >
        <Router>
          <AppRoutes />
        </Router>
      </ErrorBoundary>

      <Notice />
    </ThemeProvider>
  );
};

export default Sentry.withProfiler(App);
